import PropTypes from 'prop-types';
import { Component  } from 'react';

import { defineMessages, injectIntl } from 'react-intl';
import { NavigationPortal } from 'mastodon/components/navigation_portal';
import { identityContextPropShape, withIdentity } from 'mastodon/identity_context';
import { transientSingleColumn } from 'mastodon/is_mobile';
import { canManageReports, canViewAdminDashboard } from 'mastodon/permissions';

import ColumnLink from './column_link';
import DisabledAccountBanner from './disabled_account_banner';
import { ListPanel } from './list_panel';
import SignInBanner from './sign_in_banner';
import { ActivityIcon } from 'mastodon/components/icons/activity';
import { SettingIcon } from 'mastodon/components/icons/setting';

const messages = defineMessages({
  home: { id: 'tabs_bar.home', defaultMessage: 'Home' },
  notifications: { id: 'tabs_bar.notifications', defaultMessage: 'Notifications' },
  explore: { id: 'explore.title', defaultMessage: 'Explore' },
  firehose: { id: 'column.firehose', defaultMessage: 'Live feeds' },
  direct: { id: 'navigation_bar.direct', defaultMessage: 'Private mentions' },
  favourites: { id: 'navigation_bar.favourites', defaultMessage: 'Favorites' },
  bookmarks: { id: 'navigation_bar.bookmarks', defaultMessage: 'Bookmarks' },
  lists: { id: 'navigation_bar.lists', defaultMessage: 'Lists' },
  preferences: { id: 'navigation_bar.preferences', defaultMessage: 'Preferences' },
  administration: { id: 'navigation_bar.administration', defaultMessage: 'Administration' },
  moderation: { id: 'navigation_bar.moderation', defaultMessage: 'Moderation' },
  followsAndFollowers: { id: 'navigation_bar.follows_and_followers', defaultMessage: 'Follows and followers' },
  about: { id: 'navigation_bar.about', defaultMessage: 'About' },
  search: { id: 'navigation_bar.search', defaultMessage: 'Search' },
  advancedInterface: { id: 'navigation_bar.advanced_interface', defaultMessage: 'Open in advanced web interface' },
  openedInClassicInterface: { id: 'navigation_bar.opened_in_classic_interface', defaultMessage: 'Posts, accounts, and other specific pages are opened by default in the classic web interface.' },
  followRequests: { id: 'navigation_bar.follow_requests', defaultMessage: 'Follow requests' },
});

class NavigationPanel2 extends Component {
  toggleSidebar = () => {
    document.body.classList.remove('sidebar-visible');
    const event = new CustomEvent('toggleSidebar', { detail: { visible: false } });
    document.dispatchEvent(event);
  };
  static propTypes = {
    identity: identityContextPropShape,
    intl: PropTypes.object.isRequired,
  };
  

  render() {
    const { intl } = this.props;
    const { signedIn, disabledAccountId, permissions } = this.props.identity;

    let banner = undefined;

    if (transientSingleColumn) {
      banner = (
        <div className='switch-to-advanced'>
          {intl.formatMessage(messages.openedInClassicInterface)}
          {" "}
          <a href={`/deck${location.pathname}`} className='switch-to-advanced__toggle'>
            {intl.formatMessage(messages.advancedInterface)}
          </a>
        </div>
      );
    }

    const { closeSidebar } = this.props;

    return (
      <div className='navigation-panel2'>

        {banner &&
          <div className='navigation-panel__banner'>
            {banner}
          </div>
        }

        <div className='navigation-panel__menu'>
          <div className='close-sidebar'>

            <button onClick={this.toggleSidebar} style={{ background: 'var(--background-color)', border: 'none' }}>
            </button>

          </div>

          {!signedIn && (
            <div className='navigation-panel__sign-in-banner'>

              {disabledAccountId ? <DisabledAccountBanner /> : <SignInBanner />}
            </div>
          )}

          {signedIn && (
            <>

              {/* <ListPanel /> */}


              {/* <ColumnLink transparent href='/settings/preferences' icon='cog' iconComponent={SettingsIcon} text={intl.formatMessage(messages.preferences)} /> */}

              {canManageReports(permissions) && <ColumnLink onClick={closeSidebar} optional transparent href='/admin/reports' icon='flag' iconComponent={ActivityIcon} text={intl.formatMessage(messages.moderation)} />}
              {canViewAdminDashboard(permissions) && <ColumnLink onClick={closeSidebar} optional transparent href='/admin/dashboard' icon='tachometer' iconComponent={SettingIcon} text={intl.formatMessage(messages.administration)} />}
            </>
          )}

        </div>
        {/* <NavigationPortal /> */}
      </div>
    );
  }

}

export default injectIntl(withIdentity(NavigationPanel2));
